import React from 'react'
import { Route } from 'react-router-dom'
import PageWrapper from '../../SharedComponents/PageWrapper/PageWrapper'

type Props = {
  routes: any[]
}

export const SelfServe = ({ routes }: Props) => (
  <PageWrapper>
    {routes.map((route) => (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Route key={route.path} {...route}>
        {route.routes ? (
          <route.Component routes={route.routes} />
        ) : (
          <route.Component />
        )}
      </Route>
    ))}
  </PageWrapper>
)
